module.exports = __webpack_public_path__ + "static/media/3.3e5446ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3.svg
// module id = 844
// module chunks = 0